export const isEnterKeyPress = event => event?.key === 'Enter';
